<template>
    <v-breadcrumbs   
      :items="breadcrumbs"
      divider=">"
      large
      class="pl-0"
    >
      <template v-slot:item="props" >  
        <v-breadcrumbs-item v-if="props.item.select" >
            <v-select 
              v-model="selectedCompany"
              :items="companies"
              item-text="name"
              item-value="id"
              menu-props="offset-y"
              class="breadcrumbsSelect"
              dense
              return-object
              hide-details
              :disabled="companyChangeDisabled"
              :no-data-text="$t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE')"
              @input="changeCompany()"
            >
              <template v-slot:item="{ item }">
                  <span :alvqa="'breadcrumbs-dropdown-' + item.id">
                    {{ item.name }}
                  </span>
              </template>
              <template v-slot:selection="{ item }">
                  <span :alvqa="'breadcrumbs-dropdown-selected-' + item.id">
                    {{ item.name }}
                  </span>
              </template>
            </v-select>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item v-else-if="childName ==='lang_PUBLISHING_CAPTION_WORKS'">
            {{ (props.item.text === "Werke" || props.item.text === 'Works') && selectedPublishingComp !== '' ? props.item.text + ' (' + $t('lang_GENERIC_CURRENT_PUBLISHING_COMPANY') +': '+ selectedPublishingComp + ')' : props.item.text}}
        </v-breadcrumbs-item> 
        <v-breadcrumbs-item v-else>
          {{ props.item.text }}
        </v-breadcrumbs-item>        
      </template>
    </v-breadcrumbs>
</template>

<script>
import BaseIcon from '../_buttons/BaseIcon'

export default {
    name: "BaseBreadcrumbs",
    components: {
      BaseIcon
    },
    computed: {
        breadcrumbs() {
          let breadcrumbs = [
            {text: this.$t(this.parentName), disabled: true},
            {text: "Company", disabled: false, select: true},
            {text: this.$t(this.childName), disabled: true}
          ]

          if(this.parentName === 'lang_DASHBOARD') breadcrumbs.splice(1)
          if( this.childName === 'lang_PUBLISHING_CAPTION_WORKS' || 
              this.parentName === 'lang_GENERIC_CAPTION_AZ' || 
              this.parentName === 'lang_NAVIGATION_SERVICE_CENTER' ||
              this.childName === 'lang_ACCOUNT_MODULES'  || 
              this.childName === 'lang_ACCOUNT_COMPANIES' || 
              this.childName === 'lang_ACCOUNT_CREDENTIALS' ||
              this.childName === 'lang_ACCOUNT_MAPPINGS'
              ) breadcrumbs.splice(1,1)
          
          return breadcrumbs
        },

        // Returns true/false depending on if context is Publishing or Label
        isPublishing() { return this.parentName === 'lang_PUBLISHING' || this.childName === 'lang_CONTRACTS_PUBLISHING_CONTRACTS' }, 
        isLabel() { return this.parentName === 'lang_LABEL' || this.childName === 'lang_CONTRACTS_LABEL_CONTRACTS' },
        
        // Special case, when the Dropdown contains Publishing and Label Companies.
        isPublishingAndLabel() { 
          return ((this.parentName === 'lang_ACCOUNT' && this.childName === 'lang_ACCOUNT_SETTINGS') || (this.parentName === 'lang_ERP' )) 
        },

        // Defined in router.js
        parentName() { return this.$route.meta.parentName },
        childName() { return this.$route.meta.childName },

        /** 
         * Disables the company selector dropdown.
         * The information if a page allows to change the company is defined in the router.js meta object of the route.
         * We need this option changing the company e.g. on a EDIT page would cause an error.
         * Because the API call for an edit form would send an ALVID that may not exists in that company.
         * @return {Boolean} return true or false.
         */
        companyChangeDisabled() { 
          if(this.$route.meta.hasOwnProperty("disabledBreadcrumbs")) {
            return this.$route.meta.disabledBreadcrumbs
          } else return false
        },

        // Dropdown items for breadcrumbs, depending on context (Publishing or Label)
        companies() { 
          if(this.isPublishingAndLabel) return this.allCompanyItems
          if(this.isPublishing) return this.$store.getters.getPublishingCompanies 
          if(this.isLabel) return this.$store.getters.getLabelCompanies
        },

        // Dropdown items for breadcrumbs (without publishing or label context)
        allCompanyItems() { 
          let publishingCompanies = this.$store.getters.getPublishingCompanies
          let labelCompanies = this.$store.getters.getLabelCompanies
          let allCompanies = []

          // Put all publishing companies, if existing, in item array
          if(publishingCompanies.length > 0) {
            allCompanies.push( {header: this.$t('lang_GENERAL_CAPTION_PUBLISHING_COMPANIES')} )
            publishingCompanies.forEach(company => {
              company['context'] = 1
              allCompanies.push(company)
            });
          }

          if(labelCompanies.length > 0) {
             allCompanies.push( {header: this.$t('lang_GENERAL_CAPTION_LABEL_COMPANIES')} )
             labelCompanies.forEach(company => {
               company['context'] = 2
               allCompanies.push(company)
             })
          }

          return allCompanies 
        },

        selectedPublishingComp(){
            return this.$store.getters.getSelectedPublishingCompany 
        },
        // Get selected company, depending on (OverallCompany / publishing / label)
        selectedCompany: {
          get() { 
            if(this.isPublishing) return this.$store.getters.getSelectedPublishingCompanyId 
            if(this.isLabel) return this.$store.getters.getSelectedLabelCompanyId
            if(this.isPublishingAndLabel) return this.$store.getters.getSelectedOverAllCompany 
          },
          set(selected) { 
            if(this.isPublishing) this.$store.commit('setSelectedPublishingCompanyId', selected) 
            if(this.isLabel) this.$store.commit('setSelectedLabelCompanyId', selected)
            if(this.isPublishingAndLabel) this.$store.commit('setSelectedOverAllCompany', selected) 
          }
        }
    },
    methods: {  
        changeCompany() {
          if(this.isPublishingAndLabel) this.$store.dispatch('changeCompany')
          if(this.isPublishing) this.$store.dispatch('changeCompany', {newId: this.selectedCompany.id, context: 'publishing'})
          if(this.isLabel) this.$store.dispatch('changeCompany', {newId: this.selectedCompany.id, context: 'label'})

          if(this.$store._mutations['setSelected' + this.$route.name]) {
            this.$store.commit('setSelected' + this.$route.name , [])
          } 
          if(this.$store._mutations['setIsAllSelected' + this.$route.name]) {
            this.$store.commit('setIsAllSelected' + this.$route.name , [])
          } 
        }
    },

    mounted() {
      this.$store.commit('setSelectedPublishingCompanyId')
      this.$store.commit('setSelectedLabelCompanyId')
      this.$store.commit('setSelectedOverAllCompany')
      this.$store.commit('setPublishingCompanies')
      this.$store.commit('setLabelCompanies')
    }
}
</script>

<style>
/* see vuetify ticket:  https://github.com/vuetifyjs/vuetify/issues/6275 
https://github.com/vuetifyjs/vuetify/issues/4275 => 90% default...
*/
.breadcrumbsSelect.v-input--is-dirty input  {
  display: none;
}

.breadcrumbsSelect .v-select__selection {
  max-width: 100% !important;
}
</style>